/**
 * COPYRIGHT NOTICE
 * This file is categorized as "Custom Source Code"
 * and is subject to the terms and conditions defined in the
 * "LICENSE.txt" file, which is part of this source code package.
 */

import { TagEditor } from '@onehat/ui/src/Components/Form/Field/Tag/Tag.js';
import GroupsEditorWindow from '../../../Window/GroupsEditorWindow.js';
import { useSelector } from 'react-redux';
import {
	selectUser,
} from '../../../../models/Slices/AppSlice';
import {
	USERS__SUPER_USER,
} from '../../../../constants/Users.js';

function GroupsTagEditor(props) {
	const 
		user = useSelector(selectUser),
		comboProps = {};
	if (user?.id !== USERS__SUPER_USER) {
		comboProps.isEditor = false;
	}
	return <TagEditor
				reference="GroupsTagEditor"
				model="Groups"
				uniqueRepository={true}
				Editor={GroupsEditorWindow}
				usePermissions={true}
				_combo={comboProps}
				{...props}
			/>;
}

export default GroupsTagEditor;